export function isSameAddress(
  address: string,
  comparedAddress: string,
): boolean {
  return address.toLowerCase() === comparedAddress.toLowerCase();
}
